export const FILTER_TYPE = {
  INSTITUTION: 'institution_ids',
  PROCEDURE_GROUP: 'procedure_groups',
  SCHEDULED_DATE: 'scheduled_date',
  PATIENT_ARRIVED_FROM: 'patient_arrived_from',
  PATIENT_ARRIVED_TO: 'patient_arrived_to',
  PRIORITY: 'priority',
  STARTED_DATE_FROM: 'started_date_from',
  STARTED_DATE_TO: 'started_date_to',
  SUSPEND_DATE_FROM: 'suspend_date_from',
  SUSPEND_DATE_TO: 'suspend_date_to',
  APPROVED_DATE_FROM: 'approved_date_from',
  APPROVED_DATE_TO: 'approved_date_to',
  VISIT_ID: 'visit_id',
  PATIENT_NAME: 'patient_name',
  ORDER_GROUP: 'order_group',
  STATUS: 'status',
  PATIENT_ID: 'patient_id',
  STUDY_DESC: 'study_desc',
  MODALITIES: 'modalities',
  RECEIVED_AT: 'received_at',
};

export const INITIAL_FILTERS = {};
